<template>
  <div>
    <loading :active.sync="isLoading" 
    :can-cancel="true" 
    :on-cancel="onCancel"
    :is-full-page="fullPage"></loading>
    
    <b-alert
      v-model="showAlert"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;"
      variant="success"
      fade
      dismissible
    >
      {{alertMessage}}
    </b-alert>

    <h1>Artikel - Amazon - Mapping</h1>

    <p>SKUs können auch Variantenartikel sein. Das Mapping läuft jedoch immer über den Hauptartikel. SKU vom Hauptartikel eingeben oder von einem Variantenartikel um den kompletten Artikel zu mappen.</p>
    <button class="btn btn-primary" v-on:click="createEmpty()" style="margin-bottom: 10px;float:right;"><font-awesome-icon icon="user-plus" /> Neues Mapping</button>
    <table class="table table-bordered table-striped table-small">
      <thead>
        <tr>
          <th>#</th>
          <th>Artikel ID</th>
          <th>Name</th>
          <th>SKU</th>
          <th>Shop</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in listing" :key="item.id">
          <td>{{item.id}}</td>
          <td>{{item.article_id}}</td>
          <td>{{item.article_name}}</td>
          <td><input v-model="item.sku" placeholder="SKU" class="form-control"></td>
          <td>
            <select v-model="item.shop_id" class="form-control">
                <option disabled value="">Please select one</option>
                <option v-for="shop in shopListing" :key="shop.id" :value="shop.id">{{shop.name}}</option>
            </select>
          </td>
          <td>
            <button class="btn btn-primary" v-on:click="saveEntry(item)">
                <font-awesome-icon icon="save" />
            </button>
            <button class="btn btn-warning" v-on:click="deleteEntry(item)">
                <font-awesome-icon icon="trash" />
              </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
const request = require('superagent')
import Loading from 'vue-loading-overlay';

export default{
  name: 'AdminArticleAmazonMapping',
  components: {
    Loading
  },
  data() {
    return {listing: [],
            isLoading: false,
            fullPage: true,
            showAlert: false,
            alertMessage: "",
            api_token:"",
            shopListing: []};
  },
  computed: {
  },
  mounted: function () {
    this.api_token = localStorage.getItem('API_TOKEN')

    this.fetchData();
  },
  methods: {
      fetchData: function(){
        this.isLoading = true
        var that = this
        request
        .get(process.env.API_HOST + '/api/amazon_article_mappings')
        .set('Accept', 'application/json')
        .set("Authorization",this.api_token)
        .then(function (res) {
            that.listing = res.body
            that.isLoading = false
        })

        request
            .get(process.env.API_HOST + '/api/shops.php')
            .set('Accept', 'application/json')
            .set("Authorization",this.api_token)
            .then(function (res) {
                that.shopListing = res.body
            })
      },
      saveEntry: function(entry){
        var that = this

        request
        .put(process.env.API_HOST + '/api/amazon_article_mappings/'+entry.id)
        .send({
                sku: entry.sku,
                shop_id: entry.shop_id
                })
        .set('Accept', 'application/json')
        .set("Authorization",this.api_token)
        .then(function (res) {
            that.fetchData();
            that.alertMessage = "Mapping " + entry.sku + " wurde gespeichert!";
            that.showAlert = true;
        })
      },
      createEmpty: function(){
        var that = this

        request
        .post(process.env.API_HOST + '/api/amazon_article_mappings')
        .send({})
        .set('Accept', 'application/json')
        .set("Authorization",this.api_token)
        .then(function (res) {
            that.fetchData();
            that.alertMessage = "Neues Mapping wurde in der Liste unten hinzugefügt.";
            that.showAlert = true;
        })
      },
      deleteEntry: function(entry){
        var check = confirm('Das Mapping ' + entry.name + " wirklich löschen?"); 
	    if (check == false) {
		    return;
        }
        
        var that = this

        request
        .delete(process.env.API_HOST + '/api/amazon_article_mappings/'+entry.id)
        .set('Accept', 'application/json')
        .set("Authorization",this.api_token)
        .then(function (res) {
            that.fetchData();
            that.alertMessage = "Das Mapping " + entry.name + " wurde gelöscht!";
            that.showAlert = true;
        })
      },
      onCancel:function() {}
  }
}
</script>


// WEBPACK FOOTER //
// src/components/AdminArticleAmazonMapping.vue